<!-- Routed tab navigation. A labelled <nav> of router links — NOT a
     tablist (see component doc). The active link carries
     aria-current="page" via the #rla routerLinkActive ref. Per-tab
     visibility gated by *authGuard on child.security. -->
<nav class="tw-nav-tabs__nav" [attr.aria-label]="navLabel()">
  @for (child of tabs(); track child.id) {
    <a
      class="tw-nav-tabs__tab"
      *authGuard="child.security"
      [routerLink]="child.path"
      routerLinkActive="tw-nav-tabs__tab--active"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="{ exact: false }"
      [attr.aria-current]="rla.isActive ? 'page' : null">
      @if (child.icon) {
        <!-- F19 Wave 8 — STATIC sprite icon (ui-svg-icon), same path the
             sidebar nav uses. No IconStore / HTTP, so it always renders.
             Decorative: the adjacent label conveys the tab name. -->
        <span class="tw-nav-tabs__icon" aria-hidden="true">
          <ui-svg-icon [icon]="asSvgIcon(child.icon)" />
        </span>
      }
      <span class="tw-nav-tabs__label">{{ child.label }}</span>
      @let badge = effectiveBadge(child);
      @if (badge) {
        <tw-badge
          class="tw-nav-tabs__badge"
          [type]="badgeType(badge)"
          [status]="badgeStatus(badge)">{{ badgeLabel(badge) }}</tw-badge>
      }
    </a>
  }
</nav>
